module.exports = __webpack_public_path__ + "static/media/save.364d7bfd.svg";